export default __webpack_public_path__ + "static/media/Brain-04.d727e6f3.svg";